import FieldUtil from "../utils/FieldUtil";
import DefaultCondition from "./DefaultCondition";
import CurrentUserEmpty from "./CurrentUserEmpty";
import CurrentUserPresent from "./CurrentUserPresent";

export default class ConditionFactory {

    constructor(conditions, documents) {
        this.conditions = conditions
        this.documents = documents
    }

    // Condition data model:
    // type: "visible"
    // field_id: 82
    // predicate: "exists"

    test() {
        for( let i = 0; i < this.conditions.length; i++ ) {
            let condition = this.getCondition(this.conditions[i])

            if( !condition.test() ) {
                return false
            }
        }

        return true
    }

    getCondition(condition) {
        if(condition.predicate && condition.predicate === 'exists') {
            return this.getPresentCondition(condition)
        }
        else if(condition.predicate && condition.predicate === 'does not exist') {
            return this.getEmptyCondition(condition)
        }

        return new DefaultCondition()
    }

    getPresentCondition(condition) {
        console.log('getPresentCondition')
        let field = webase.managers.app.getField(condition.field_id)
        let fieldUtil = new FieldUtil(field)

        if(fieldUtil.isCurrentUser()) {
            return new CurrentUserPresent(field, this.documents, webase.model.currentUser)
        }

        return new DefaultCondition()
    }

    getEmptyCondition(condition) {
        let field = webase.managers.app.getField(condition.field_id)
        let fieldUtil = new FieldUtil(field)

        if(fieldUtil.isCurrentUser()) {
            return new CurrentUserEmpty(field, this.documents, webase.model.currentUser)
        }

        return new DefaultCondition()
    }
}